/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const onInitialClientRender = () => {
  // Remove the default hash from the URL on the initial load
  window.history.replaceState({}, document.title, window.location.pathname);
};
